module.exports = __webpack_public_path__ + "img/index5.64adaeea.png";